import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const productImage = 'https://cdn.magicpatterns.com/uploads/7KHpuz45MwLcVettH6PoTv/ChatGPT-Image-14-jul-2026_-01_43_33-p.m..webp';
export function Hero() {
  return <section className="border-b-4 border-brand-beigeDeep bg-brand-cream px-4 pb-5 pt-6 text-center sm:px-6" data-id="element-82">
      <div className="mx-auto mb-3 inline-flex items-center rounded-full border border-brand-gold/40 bg-brand-goldLight/45 px-3 py-1 text-[10px] font-bold tracking-wide text-brand-burgundy sm:text-xs" data-id="element-83">
        FÜR TANZLEHRER IM DEUTSCHSPRACHIGEN RAUM
      </div>
      <h1 className="mx-auto mb-3 max-w-2xl text-[30px] font-bold leading-[1.12] sm:text-4xl" data-id="element-84">
        Das komplette Planungssystem für Tanzlehrer
      </h1>
      <p className="mx-auto mb-4 max-w-2xl text-sm font-medium leading-relaxed sm:text-base" data-id="element-85">
        Spare jede Woche Stunden bei der Unterrichtsvorbereitung,
        Choreografieerstellung, Semesterplanung und Schülerentwicklung – ohne
        jede Tanzstunde von Grund auf neu zu erstellen.
      </p>
      <a href="#pricing" className="mb-4 block" aria-label="Zur Kaufsektion" data-id="element-86">
        <img src={productImage} alt="DANCE PRO™ – Das komplette Planungssystem für Tanzlehrer" className="mx-auto w-full max-w-[320px] rounded-sm object-contain drop-shadow-xl transition-transform duration-200 hover:scale-[1.01]" data-id="element-87" />
      </a>
      <div className="mx-auto mb-3 max-w-xl" data-id="element-88">
        <CTAButton data-id="element-89">🚀 JA! ICH WILL DANCE PRO™ JETZT</CTAButton>
      </div>
      <div className="flex flex-col items-center justify-center gap-1.5 text-[11px] font-bold text-brand-text sm:flex-row sm:gap-4 sm:text-xs" data-id="element-90">
        <span className="flex items-center gap-1" data-id="element-91">
          <StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" data-id="element-92" />⭐
          4.9/5 — Bewertungen von Tanzlehrern aus Deutschland, Österreich und
          der Schweiz
        </span>
        <span className="flex items-center gap-1" data-id="element-93">
          <ShieldCheckIcon className="h-4 w-4 text-brand-burgundy" data-id="element-94" />
          🛡️ 7 Tage Geld-zurück-Garantie — Vollständig risikolos
        </span>
      </div>
    </section>;
}